import classNames from 'classnames'
import React, { useEffect } from 'react'

import { Button, BUTTON_TYPES, Icon } from '@src/quince-components/src'

import styles from './apple-pay-button.module.scss'
import ApplePayIcon from './icons/apple-pay.svg'
import { useApplePayBraintree } from './use-apple-pay-braintree.hook'

import type { ApplePayButtonProps } from './apple-pay-button.types'

const ApplePayButtonLegacy = ({
  className,
  dataSelectorKey,
  productPrice,
  applePayConfig,
  onReady,
  enableAnimation,
  disableClick,
}: ApplePayButtonProps) => {
  const {
    getCheckoutDetails,
    onError,
    validateApplePayClick,
    updateShippingAddress,
    updateShippingOption,
    checkoutExpressUpdateDetail,
    updateExpressCompleteDetails,
    capture,
    skipEmail,
    disableApplePayExpress,
    getZeroAmountCheckoutUrl,
    showZeroAmountCheckoutModal,
  } = applePayConfig

  const { isApplePayClickInProgress, isSupported, handleApplePayClick } = useApplePayBraintree({
    onError,
    getCheckoutDetails,
    validateApplePayClick,
    updateShippingAddress,
    productPrice,
    updateShippingOption,
    checkoutExpressUpdateDetail,
    updateExpressCompleteDetails,
    capture,
    skipEmail,
    getZeroAmountCheckoutUrl,
    showZeroAmountCheckoutModal,
  })

  const isSupportsApplePay = isSupported && !disableApplePayExpress
  const [shouldAnimate, setShouldAnimate] = React.useState(false)

  useEffect(() => {
    if (!isSupportsApplePay || !enableAnimation) {
      return
    }
    const timer = requestAnimationFrame(() => {
      setShouldAnimate(true)
      onReady?.()
    })
    return () => {
      cancelAnimationFrame(timer)
    }
  }, [isSupportsApplePay, onReady, enableAnimation])

  if (!isSupported || disableApplePayExpress) {
    return null
  }

  return (
    <Button
      onClick={handleApplePayClick}
      data-selector-key={dataSelectorKey}
      type={BUTTON_TYPES.SECONDARY}
      className={classNames(
        className,
        styles.applePayButton,
        enableAnimation && styles.applePayButtonAnimated,
        enableAnimation && shouldAnimate && styles.applePayButtonExpanded,
      )}
      showLoader={isApplePayClickInProgress}
      disabled={disableClick || (enableAnimation && !shouldAnimate)}
    >
      <Icon iconSvg={ApplePayIcon} className={styles.applePayIcon} />
    </Button>
  )
}

export default ApplePayButtonLegacy
